import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Pillars } from "@/components/Pillars";
import { Location } from "@/components/Location";
import { Schedule } from "@/components/Schedule";
import { Quiz } from "@/components/Quiz";
import { BookingQuiz } from "@/components/BookingQuiz";
import { Retreats } from "@/components/Retreats";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <main className="bg-sand overflow-x-hidden" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Pillars />
      <Location />
      <Schedule />
      <Quiz />
      <BookingQuiz />
      <Retreats />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
